export const projectsData = [

    {
        projectName: 'EtherSiim',
        projectDescription:
            'EtherSiim: Decentralized Cryptographic Pseudonymous Economy (DCPE)',
        imageUrl: 'https://madhavbahl.tech/portfolio-assets/proj3.PNG',
        videoUrl:
            'https://twitter.com/ethersiim',
        projectUrl: 'https://twitter.com/ethersiim',
    },
    {
        projectName: 'Name It!',
        projectDescription:
            'Do you find it difficult to name your projects or ventures? Fear not! Check out this cool name suggestion application which will help you find the best name for your next project, venture, or startup. Keep building!',
        imageUrl: 'https://madhavbahl.tech/portfolio-assets/proj1.PNG',
        videoUrl:
            'https://github.com/aaronsiim/nameit-react-app',
        projectUrl: 'https://github.com/aaronsiim/nameit-react-app',
    },
    {
        projectName: 'FlashType',
        projectDescription:
            'Having a good typing speed will always help you as a developer! Here, I present you the typing speed test application, where you can check your typing speed (in wpm) and share the results with your friends too.',
        imageUrl: 'https://madhavbahl.tech/portfolio-assets/proj2.PNG',
        videoUrl:
            'https://github.com/aaronsiim/flashtype',
        projectUrl: 'https://github.com/aaronsiim/flashtype',
    },
    {
        projectName: 'Flexbox Cheatsheet',
        projectDescription:
            'A frontend web developer must know the concepts of CSS Flexbox. So here is a CSS Flexbox cheatsheet, built using CSS Flexbox. Learn the concepts of flexbox by building a cheatsheet which is built using flexbox. Super cool!',
        imageUrl: 'https://madhavbahl.tech/portfolio-assets/proj3.PNG',
        videoUrl:
            'https://github.com/aaronsiim/flexbox-boilerplate-css',
        projectUrl: 'https://github.com/aaronsiim/flexbox-boilerplate-css',
    },
    {
        projectName: 'PokeDex',
        projectDescription:
            "Pokemon was a huge part of our childhood, wasn't it? Talking about pokemon brings back so many memories, but do you remember the details of each pokemon? Probably No! So here I bring you a pokedex to check all pokemons :)",
        imageUrl: 'https://madhavbahl.tech/portfolio-assets/proj4.PNG',
        videoUrl:
            'https://github.com/aaronsiim/pokedex-app',
        projectUrl: 'https://github.com/aaronsiim/pokedex-app',
    },
    {
        projectName: 'Portfolio Website',
        projectDescription:
            'As a developer/designer, you should definitely have your own portfolio website. There are endless benefits. But, a lot of people feel that it would be tough to make one. So here I bring you a tutorial to make your own website.',
        imageUrl: 'https://madhavbahl.tech/portfolio-assets/proj5.PNG',
        videoUrl: 'https://github.com/aaronsiim/aaron-portfolio',
        projectUrl: 'https://github.com/aaronsiim/aaron-portfolio',
    },
];
